import { useEffect } from 'react';
import I18n from 'I18n';
import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
import Raven from 'raven-js';
import { useUnifiedAccount } from 'unified-auth';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UnifiedAccReconnectButton = ({
  buttonComponent: ButtonComponent,
  buttonProps,
  'data-test-id': dataTestId,
  failed: propsFailed,
  loading: propsLoading,
  label,
  metadata,
  onAuthCancelled,
  onAuthStarted,
  onAuthSucceeded
}) => {
  const portalId = PortalIdParser.get();
  const appId = (metadata === null || metadata === void 0 ? void 0 : metadata.appId) || 0;
  const accountId = Number((metadata === null || metadata === void 0 ? void 0 : metadata.accountId) || '0');
  useEffect(() => {
    if (!(appId && accountId)) {
      const err = new Error('ReconnectButton requires appId');
      if (!enviro.deployed()) {
        console.error(err);
      }
      Raven.captureException(err);
      onAuthCancelled === null || onAuthCancelled === void 0 || onAuthCancelled({
        error: err,
        errorMessage: I18n.text('reconnect.errors.reconnectFailed')
      });
    }
  }, [appId, accountId, onAuthCancelled]);
  const onComplete = response => {
    onAuthSucceeded === null || onAuthSucceeded === void 0 || onAuthSucceeded(String(response.accountId));
  };
  const onCancel = () => {
    onAuthCancelled === null || onAuthCancelled === void 0 || onAuthCancelled({
      error: null,
      errorMessage: I18n.text('reconnect.warnings.reconnectionCancelled')
    });
  };
  const {
    isLoading,
    Modal,
    openModal,
    isOpen
  } = useUnifiedAccount({
    appId,
    portalId,
    accountId: Number(accountId)
  }, {
    onComplete,
    onCancel
  });
  const handleClick = evt => {
    var _buttonProps$onClick;
    buttonProps === null || buttonProps === void 0 || (_buttonProps$onClick = buttonProps.onClick) === null || _buttonProps$onClick === void 0 || _buttonProps$onClick.call(buttonProps, evt);
    onAuthStarted === null || onAuthStarted === void 0 || onAuthStarted();
    openModal();
  };
  const loading = isLoading || propsLoading || isOpen;
  const failed = propsFailed === undefined || propsFailed;
  const updatedButtonProps = Object.assign({}, buttonProps || {}, {
    onClick: handleClick,
    'data-test-id': dataTestId,
    disabled: (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.disabled) || loading || propsLoading
  });
  const cta = ButtonComponent ? /*#__PURE__*/_jsx(ButtonComponent, Object.assign({}, updatedButtonProps, {
    children: label
  })) : /*#__PURE__*/_jsx(LoadingButton, Object.assign({}, updatedButtonProps, {
    failed: failed,
    loading: loading,
    children: label
  }));
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [cta, Modal]
  });
};